import { useState } from 'react';
import { USER_CREATABLE_ORG_TYPES, type OrgRequestInput } from '@ready/shared';
import { ORG_TYPE_LABELS } from '@/lib/labels';
import { Button, ErrorText, Field, Input, Select, Textarea } from './ui';

export function OrgRequestForm({
  pending,
  error,
  onSubmit,
}: {
  pending: boolean;
  error: unknown;
  onSubmit: (input: OrgRequestInput) => void;
}) {
  const [form, setForm] = useState({
    name: '',
    type: 'university',
    country: 'IN',
    website: '',
    domain: '',
    expectedMembers: '',
    message: '',
  });
  const set =
    (k: keyof typeof form) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) =>
      setForm((f) => ({
        ...f,
        [k]: k === 'country' ? e.target.value.toUpperCase() : e.target.value,
      }));

  return (
    <form
      className="grid gap-4 sm:grid-cols-2"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({
          ...form,
          expectedMembers: Number(form.expectedMembers),
        } as unknown as OrgRequestInput);
      }}
    >
      <Field label="Organization name" htmlFor="req-name">
        <Input id="req-name" required minLength={2} value={form.name} onChange={set('name')} />
      </Field>
      <Field label="Type" htmlFor="req-type">
        <Select id="req-type" value={form.type} onChange={set('type')}>
          {USER_CREATABLE_ORG_TYPES.map((t) => (
            <option key={t} value={t}>
              {ORG_TYPE_LABELS[t]}
            </option>
          ))}
        </Select>
      </Field>
      <Field label="Country" htmlFor="req-country" hint="Two-letter code, e.g. IN">
        <Input
          id="req-country"
          required
          maxLength={2}
          value={form.country}
          onChange={set('country')}
        />
      </Field>
      <Field label="Expected members" htmlFor="req-members">
        <Input
          id="req-members"
          type="number"
          min={1}
          required
          value={form.expectedMembers}
          onChange={set('expectedMembers')}
        />
      </Field>
      <Field label="Website" htmlFor="req-website">
        <Input
          id="req-website"
          type="url"
          placeholder="https://university.edu"
          value={form.website}
          onChange={set('website')}
        />
      </Field>
      <Field
        label="Email domain"
        htmlFor="req-domain"
        hint="Members with this email domain can join automatically"
      >
        <Input
          id="req-domain"
          placeholder="university.edu"
          value={form.domain}
          onChange={set('domain')}
        />
      </Field>
      <div className="sm:col-span-2">
        <Field label="What will you use Nirvik Ready for?" htmlFor="req-message">
          <Textarea id="req-message" rows={3} value={form.message} onChange={set('message')} />
        </Field>
      </div>
      <div className="flex items-center gap-4 sm:col-span-2">
        <Button type="submit" disabled={pending}>
          Send request
        </Button>
        <ErrorText error={error} />
      </div>
    </form>
  );
}
